import { Component, ElementRef, OnInit, ViewChild, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NewsService } from '../../services/news.service';
import { News } from '../../interfaces/news.interface';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import { CommonsService } from '../../services/common.service';


@Component({
  selector: 'app-news-detail',
  standalone: false,
  templateUrl: './news-detail.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./news-detail.component.scss']
})
export class NewsDetailComponent implements OnInit, AfterViewInit {
  news?: News;
  loading = true;
  @ViewChild('contentContainer', { static: false }) contentContainer!: ElementRef;
  imagesUrl = `${environment.ImagesUrl}/news/`;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private newsService: NewsService,
    private commonsService: CommonsService  ,
    private location: Location,
     private titleService: Title, // <-- inject
    private metaService: Meta    // <-- inject
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.paramMap.get('id'));
    if (id) {
      this.newsService.getNews(id).subscribe({
        next: (data) => {
          this.news = data;
          this.loading = false;

          this.titleService.setTitle('Zgrane Grono -' + data.title);
          this.metaService.updateTag({ name: 'description', content: data.intro });
    
          // Attach link handlers after content is loaded
          setTimeout(() => this.attachLinkHandlers(), 100);
        },
        error: () => {
          this.loading = false;
        }
      });
    } else {
      this.loading = false;
    }
  }

  ngAfterViewInit(): void {
    // Initial attachment in case content is already rendered
    if (this.news) {
      setTimeout(() => this.attachLinkHandlers(), 100);
    }
  }

  private attachLinkHandlers(): void {
    if (!this.contentContainer?.nativeElement) {
      return;
    }

    const content = this.contentContainer.nativeElement;
    this.commonsService.attachInternalLinkHandlers(content, this.router);
  }

  getTimeAgo(created: string): string {
    return this.commonsService.getTimeAgo(created);
  
  }


  goBack() {
    this.location.back();
  }
}